import { isNil, isString, size, toString } from "lodash";

export const BLUE_COLOR = "#3333ff";
export const WHITE_COLOR = "#fff";
export const ORANGE_COLOR = "#f38032";
export const YELLOW_COLOR = "#ffc720";
export const PALE_BLUE_COLOR = "#ccecff";
export const LIGHT_BLUE_COLOR = "#0099FF";
export const STEEL_BLUE_COLOR = "#4472c4";
export const SKY_BLUE_COLOR = "#5B9BD5";
export const BLUE2_COLOR = "#3366ff";
export const BLUE_LINE = "#00c";

//background old-even row
export const LIGHT_BLUE_OLD_BACKGROUND = "#bdd7ee";
export const LIGHT_BLUE_EVEN_BACKGROUND = "#ddebf7";
export const ORANGE_OLD_BACKGROUND = "#f8cbad"; //old
export const ORANGE_EVEN_BACKGROUND = "#fce4d6"; //even
export const YELLOW_OLD_BACKGROUND = "#FFE699"; //old
export const YELLOW_EVEN_BACKGROUND = "#FFF2CC"; //even
export const STEEL_BLUE_OLD_BACKGROUND = "#D8E1F2"; //old
export const STEEL_BLUE_EVEN_BACKGROUND = "#B4C6E7"; //even
export const SKY_BLUE_BACKGROUND = "#5B9BD5";
export const PALE_BLUE_BACKGROUND = "#bee1f5";

export const reFormatValue = (element: any, key: string) => {
  const value = element?.[key];

  if (
    value === "0" ||
    value === 0 ||
    value === "-" ||
    isNil(value) ||
    value === ""
  ) {
    return "";
  }

  if (isFinite(value)) {
    return Number(value).toLocaleString("ja-JP");
  }

  if (isString(value)) {
    if (key !== "課税所得額") {
      const rawValue = value.replace(/,/g, "");
      const parsedValue = parseFloat(rawValue);
      return isNaN(parsedValue) ? "" : parsedValue.toLocaleString("ja-JP");
    } else {
      const numberPart = value.match(/[-0-9.,]+/);

      if (numberPart) {
        const numberPartStr = numberPart[0];
        const rawValue = numberPartStr.replace(/,/g, "");
        const parsedValue = parseFloat(rawValue);

        if (!isNaN(parsedValue)) {
          const formattedNumber = parsedValue.toLocaleString("ja-JP");
          return value.replace(numberPartStr, formattedNumber);
        }
      }

      return value;
    }
  }

  return "";
};

export const reFormatWorkValue = (element: any) => {
  return !isNil(element?.value) &&
    element?.value !== 0 &&
    element?.value !== "0"
    ? toHalfWidth(
        `${element?.value?.toLocaleString("ja-JP")} ${
          !isNil(element?.unit) ? element?.unit : ""
        }`,
      )
    : "";
};
export const reFormatLastRowWorkValue = (element: any, unit?: string) => {
  return !isNil(element) && element !== 0 && element !== "0"
    ? `${element?.toLocaleString("ja-JP")} ${unit ?? ""}`
    : "";
};

export const addBreaks = (text: string) => {
  if (!text) return "";
  // if (/^[\d,]+$/.test(text) && text.includes(",")) {
  //   // Add space after each comma for positive numbers too
  //   return text.replace(/,/g, ","); // Changed to add space after comma
  // }

  // NEW CASE: Handle number with comma followed by space and other characters
  if (/^[\d,]+\s+.+$/.test(text) && text.includes(",")) {
    // Split by first space occurrence
    const [numberPart, restPart] = text.split(/\s+(.+)/);

    // Format the number part by adding spaces after commas
    const formattedNumber = numberPart.replace(/,/g, ", ");

    // Rejoin the formatted number with the rest of the text
    return `${formattedNumber} ${restPart}`;
  }

  if (/[\d,]+ [a-zA-Z]+/.test(text)) {
    const parts = text.split(" ");
    const result = [];

    for (const part of parts) {
      if (/[\d,]+/.test(part) && /\d/.test(part)) {
        const segments = part.split(",");
        result.push(segments.join(" ,"));
      } else {
        result.push(part);
      }
    }

    return result.join(" ");
  }

  if (/^-[\d,]+$/.test(text) && text.includes(",")) {
    // Instead of just preserving, add space after each comma
    return text.replace(/,/g, ", ");
  }

  // Existing case for positive numbers with commas
  if (/^[\d,]+$/.test(text) && text.includes(",")) {
    // Add space after each comma for positive numbers too
    return text.replace(/,/g, ",");
  }

  // NEW CASE: Handle negative numbers without commas
  if (/^-\d+$/.test(text) && text.length > 4) {
    // Length > 4 because of the "-" sign
    let result = "-"; // Start with the negative sign
    // Skip the "-" sign when processing digits
    for (let i = 1; i < text.length; i += 3) {
      if (i > 1) result += " ";
      result += text.substring(i, Math.min(i + 3, text.length));
    }
    return result;
  }
  if (text.includes(" ")) {
    const words = text.split(" ");
    const processedWords = words.map((word) => {
      if (/^\d+$/.test(word) && word.length > 3) {
        let result = "";
        for (let i = 0; i < word.length; i += 3) {
          if (i > 0) result += " ";
          result += word.substring(i, i + 3);
        }
        return result;
      } else if (word.length > 5) {
        return chunkText(word, 5);
      }
      return word;
    });

    return processedWords.join(" ");
  }

  if (/^\d+$/.test(text) && text.length > 3) {
    let result = "";
    for (let i = 0; i < text.length; i += 3) {
      if (i > 0) result += " ";
      result += text.substring(i, i + 3);
    }
    return result;
  }
  return chunkText(text, 5);
};

const chunkText = (text: string, chunkSize: number): string => {
  if (text.includes("-") || text.includes("_")) {
    text = text.replace(/([_-])/g, " $1 ");

    if (text.includes(" ")) {
      return text
        .split(" ")
        .map((segment) =>
          segment.length > chunkSize ? chunkText(segment, chunkSize) : segment,
        )
        .join(" ");
    }
  }

  let result = "";
  for (let i = 0; i < text.length; i += chunkSize) {
    if (i > 0) result += " ";
    result += text.substring(i, i + chunkSize);
  }

  return result;
};

export const checkDataLengthLargeThan11 = (data: { [key: string]: any }) => {
  const longValues = Object?.entries(data)?.filter(
    ([key, value]) => value?.length > 11,
  );
  return size(longValues) > 0;
};
export const chunkData = (data: any[], chunkSize: number) => {
  const chunks = [];
  for (let i = 0; i < data.length; i += chunkSize) {
    chunks.push(data.slice(i, i + chunkSize));
  }
  return chunks;
};
export const ROW5_ITEMS_PER_PAGE = 30;
export const returnLastRow = (
  element: JSX.Element,
  itemIndex: number,
  data?: { [key: string]: string | number }[],
) => {
  const totalPage = Math?.ceil(size(data) / ROW5_ITEMS_PER_PAGE);

  if (totalPage === 0 && itemIndex === 0) {
    return element;
  } else if (totalPage === 1) {
    if (size(data) === ROW5_ITEMS_PER_PAGE && itemIndex === 1) {
      return element;
    } else if (size(data) < ROW5_ITEMS_PER_PAGE && itemIndex === 0) {
      return element;
    }
  } else if (totalPage > 1 && totalPage === itemIndex + 1) {
    return element;
  }
};
export const returnSizeRow5 = (
  provisionsProvision?: { [key: string]: string | number }[],
  provisionArrangement?: { [key: string]: string | number }[],
  transfersData?: { [key: string]: string | number }[],
) => {
  const maxRow5 = [
    size(provisionsProvision) <= ROW5_ITEMS_PER_PAGE
      ? size(provisionsProvision) + 1
      : size(provisionsProvision),
    size(provisionArrangement) <= ROW5_ITEMS_PER_PAGE
      ? size(provisionArrangement) + 1
      : size(provisionArrangement),
    size(transfersData) <= ROW5_ITEMS_PER_PAGE
      ? size(transfersData) + 1
      : size(transfersData),
  ];
  return Math?.max(...maxRow5);
};
export const toHalfWidth = (text?: string) =>
  toString(text)
    ?.replace(/[\uFF01-\uFF5E]/g, (ch) =>
      String?.fromCharCode(ch?.charCodeAt(0) - 0xfee0),
    )
    ?.replace(/[\u3000]/g, " ");
